import React from 'react';
import CheckboxControl from './CheckboxControl';

const TableFooter = ({ 
  tableId, 
  tbodyStyle, 
  lastRow, 
  renderAddNote, 
  handleCheckedMatched, 
  handleStayCheckedMatched, 
  handleCheckboxChange, 
  markForExport 
}) => {
  return (
    <tbody style={tbodyStyle}>
      <tr style={lastRow}>
        {renderAddNote(tableId)}
        <div>
          <CheckboxControl 
            id={tableId}
            isChecked={handleStayCheckedMatched(tableId)}
            onChange={() => handleCheckedMatched(tableId)}
            label={handleStayCheckedMatched(tableId) ? "Confirmed No-Match" : "Potential No-Match"}
          />

          <CheckboxControl 
            id={tableId}
            isChecked={markForExport.has(tableId)}
            onChange={() => handleCheckboxChange(tableId)}
            label="Mark For Export"
          />
        </div>
      </tr>
    </tbody>
  );
};

export default TableFooter;
